@if (
  {
    tactics: tactics$ | async,
    cyborgMitreFilter: cyborgMitreFilter$ | async,
  };
  as data
) {
  @if (!(data.tactics && data.cyborgMitreFilter)) {
    <div class="loading">
      <kendo-loader type="pulsing" themeColor="primary" size="large">
      </kendo-loader>
    </div>
  } @else {
    <section class="example-section">
      <hyperkit-toggle
        [disabled]="deployedChecked"
        labelLeft="Staged Hunt Packages"
        [isChecked]="stagedChecked"
        (changed)="toggleStagedDeploys()"
      >
      </hyperkit-toggle>
      <hyperkit-toggle
        labelLeft="Deployed Hunt Packages"
        [isChecked]="deployedChecked"
        (changed)="toggleDeployedDeploys()"
      >
      </hyperkit-toggle>
    </section>
    <mitre-section>
      <table>
        <thead>
          <tr>
            @for (column of headers; track column) {
              <th>
                <div class="mitre-header-card" title="{{ column | titlecase }}">
                  <hyperkit-typography
                    display="inline"
                    variant="emphasized"
                    align="left"
                    size="sm"
                    color="primary"
                    >{{ column | titlecase }}</hyperkit-typography
                  >
                </div>
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (i of rows$ | async; track i) {
            <tr>
              @for (tactic of data.tactics; track tactic) {
                <td>
                  @if (tactic.children[i]) {
                    <mitre-card
                      [cyborgMitreFilter]="data.cyborgMitreFilter"
                      [companyDeployedMitreFilter]="deployedDeploys$ | async"
                      [companyStagedMitreFilter]="stagedDeploys$ | async"
                      [tactic]="tactic"
                      [child]="tactic.children[i]"
                    ></mitre-card>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </mitre-section>
  }
}
